import { render, staticRenderFns } from "./tradesperson-dashboard.vue?vue&type=template&id=9a949046"
import script from "./tradesperson-dashboard.vue?vue&type=script&lang=js"
export * from "./tradesperson-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports